<template>
    <footer class="bg-background-dark text-white pt-16 pb-8 px-6 lg:px-40">
        <div class="layout-content-container max-w-[1080px] mx-auto">
            <div class="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
                <div class="col-span-1 md:col-span-1">
                    <div class="flex items-center gap-2 mb-4 text-primary">
                        <RouterLink :to="getRoute('/')" class="inline-flex items-center gap-2">
                            <img
                                src="/images/brand/bitpeak-logo-light.svg"
                                alt="BitPeak"
                                class="h-8 w-auto"
                                width="113"
                                height="32"
                                decoding="async"
                                fetchpriority="low"
                                loading="lazy"
                            />
                        </RouterLink>
                    </div>
                    <p class="text-gray-400 text-sm leading-relaxed">
                        {{ t('footer.tagline') }}
                    </p>
                </div>

                <div>
                    <h4 class="font-bold mb-6 text-primary">{{ t('footer.company') }}</h4>
                    <ul class="flex flex-col gap-3 text-sm text-gray-400">
                        <li>
                            <RouterLink class="hover:text-white transition-colors" :to="getRoute('/team')">
                                {{ t('nav.about') }}
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink class="hover:text-white transition-colors" :to="getRoute('/projects')">
                                {{ t('nav.projects') }}
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink class="hover:text-white transition-colors" :to="getRoute('/team')">
                                {{ t('nav.team') }}
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink class="hover:text-white transition-colors" :to="getRoute('/success-stories')">
                                {{ t('nav.success_stories') }}
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink class="hover:text-white transition-colors" :to="getRoute('/insights')">
                                {{ t('nav.insights') }}
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink class="hover:text-white transition-colors" :to="getRoute('/contact')">
                                {{ t('nav.contact') }}
                            </RouterLink>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 class="font-bold mb-6 text-primary">{{ t('footer.projects') }}</h4>
                    <ul class="flex flex-col gap-3 text-sm text-gray-400">
                        <!-- Adjust the slugs to match your real project detail routes -->
                        <li>
                            <RouterLink
                                class="hover:text-white transition-colors"
                                :to="{ name: 'project-details', params: { slug: 'sman-cars-platform', locale: locale } }"
                            >
                                Sman Cars
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink
                                class="hover:text-white transition-colors"
                                :to="{ name: 'project-details', params: { slug: 'nextlegal-pwa', locale: locale } }"
                            >
                                NextLegal PWA
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink
                                class="hover:text-white transition-colors"
                                :to="{ name: 'project-details', params: { slug: 'food-la-route-platform', locale: locale } }"
                            >
                                Food la Route
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink class="hover:text-white transition-colors" :to="getRoute('/projects')">
                                {{ t('projects.view_all') }}
                            </RouterLink>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 class="font-bold mb-6 text-primary">{{ t('footer.contact') }}</h4>
                    <ul class="flex flex-col gap-3 text-sm text-gray-400">
                        <li class="flex items-center gap-2">
                            <span class="material-symbols-outlined text-base">mail</span>
                            <a class="hover:text-white transition-colors" href="mailto:administration@bitpeak.io">
                                administration@bitpeak.io
                            </a>
                        </li>
                        <li class="flex items-center gap-2">
                            <span class="material-symbols-outlined text-base">call</span>
                            <a class="hover:text-white transition-colors" href="tel:+31702230779">
                                +31 70 223 0779
                            </a>
                        </li>
                        <li class="flex items-center gap-2">
                            <span class="material-symbols-outlined text-base">location_on</span>
                            Den Haag, Nederland
                        </li>
                    </ul>
                </div>
            </div>

            <div
                class="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500"
            >
                <p>{{ t('footer.copyright') }}</p>

                <!-- Uncomment when you have pages/routes -->
                <!--
                <div class="flex gap-6">
                  <RouterLink class="hover:text-white" :to="getRoute('/privacy')">{{ t('footer.privacy') }}</RouterLink>
                  <RouterLink class="hover:text-white" :to="getRoute('/terms')">{{ t('footer.terms') }}</RouterLink>
                </div>
                -->
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { RouterLink } from 'vue-router';

const { t, locale } = useI18n();

const getRoute = (path: string) => {
  const currentLocale = locale.value;
  if (path.startsWith('/')) {
      return `/${currentLocale}${path}`.replace('//', '/');
  }
  return path;
};
</script>
